<template>
  <div class="share-poster-container" @click="close" v-if="visible">
    <div class="poster">
      <div class="poster-wrapper">
        <div class="poster-wrapper-scroll">
          <img :src="url" @click.stop />
        </div>
      </div>
      <div class="tip" @click.stop>
        长按图片保存海报<br />或点击右上方···转发
      </div>
    </div>
    <div class="bar" @click.stop v-if="moreOption.length">
      <div class="close" @click="close">
        <Icon name="close" />
      </div>
      <div class="list">
        <!-- <div
          v-show="hideOption.indexOf(item.text) === -1"
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="guideOpen"
        >
          <img :src="item.img" />
          <div class="text">{{ item.text }}</div>
        </div> -->
        <div
          class="item"
          v-for="(item, index) in moreOption"
          :key="index"
          @click="customHandler(item)"
        >
          <img :src="item.img" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <Guide v-if="guideVisible" @close="guideClose" />
  </div>
</template>

<script>
import browserType from '@/utils/browserType'
import Guide from './guide'
import { mapState } from 'vuex'
import { Toast, Icon } from 'vant'
import { getWechatSign } from '@/api/login'
export default {
  components: { Guide, Icon },
  computed: {
    ...mapState({
      visible: (state) => state.sharePoster.visible,
      url: (state) => state.sharePoster.url,
      title: (state) => state.sharePoster.title,
      desc: (state) => state.sharePoster.desc,
      link: (state) => state.sharePoster.link,
      imgUrl: (state) => state.sharePoster.imgUrl,
      moreOption: (state) => state.sharePoster.moreOption,
      hideOption: (state) => state.sharePoster.hideOption,
    }),
  },
  data() {
    return {
      browserType: null,
      guideVisible: false,
      routeChange: true, // 路由是否改变 避免重复注册
      list: [
        {
          img: require('@/assets/share/wechat.png'),
          text: '微信',
        },
        {
          img: require('@/assets/share/wechat-moments.png'),
          text: '朋友圈',
        },
        // {
        //   img: require('@/assets/share/link.png'),
        //   text: '分享链接',
        // },
        // {
        //   img: require('@/assets/share/poster.png'),
        //   text: '下载海报',
        // },
      ],
      ios: false,
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.routeChange = true
        this.close()
      },
    },
    visible(val) {
      if (val && this.browserType === 'weixin') {
        if (this.routeChange) {
          this.wxSetConfig()
        } else {
          this.wxShare()
        }
      }
    },
  },
  created() {
    this.browserType = browserType()
    this.ios = this.isIos()
  },
  methods: {
    // 判断是否是ios
    isIos() {
      if (navigator.userAgent.indexOf('iPhone') !== -1) {
        return window.location.origin + '/'
      }
      return false
    },
    wxSetConfig() {
      console.log('开始获取配置信息')
      let params = { url: window.location.href }
      if (this.ios) {
        params = { url: this.ios }
      }
      getWechatSign(params).then((res) => {
        console.log('开始初始化')
        this.wxjs.config({
          // debug: true,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
        })
        this.wxShare()
      })
    },
    wxShare() {
      console.log('等待ready')
      this.wxjs.ready(() => {
        console.log('已完成初始化')

        this.routeChange = false
        // 分享给朋友
        console.log({
          title: this.title,
          desc: this.desc || '',
          link: this.link,
          imgUrl: this.imgUrl,
        })
        this.wxjs.updateAppMessageShareData({
          title: this.title,
          desc: this.desc || '',
          link: this.link,
          imgUrl: this.imgUrl,
          success: () => {
            console.log('分享给朋友设置成功')
          },
        })
        // 分享给朋友圈
        this.wxjs.updateTimelineShareData({
          title: this.title,
          link: this.link,
          imgUrl: this.imgUrl,
          success: () => {
            console.log('分享给朋友圈设置成功')
          },
        })
      })
      this.wxjs.error((err) => {
        console.log('微信初始化失败：' + JSON.stringify(err))
      })
    },
    guideOpen() {
      this.guideVisible = true
    },
    close() {
      this.guideClose()
      this.$store.dispatch('sharePoster/hide')
    },
    guideClose() {
      this.guideVisible = false
    },
    customHandler(item) {
      switch (item.text) {
        case '邀新码复制':
          try {
            const input = document.createElement('input')
            input.value = item.invitationCode
            document.body.appendChild(input)
            input.setAttribute('readonly', 'readonly')
            input.select()
            input.setSelectionRange(0, input.value.length),
              document.execCommand('Copy')
            Toast.success('已复制到剪切板')
            document.body.removeChild(input)
          } catch (error) {
            Toast.fail('复制失败')
          }

          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.share-poster-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .poster {
    position: relative;
    // display: flex;
    // align-items: center;
    // flex-direction: column;
    flex: 1;
    min-height: 0;
    width: 600px;
    padding: 40px 0 90px;
    .poster-wrapper {
      height: 100%;
      width: 100%;
      border-radius: 16px;
      overflow: hidden;
      .poster-wrapper-scroll {
        display: flex;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        align-items: center;
        img {
          height: auto;
          margin: 0 auto;
          border-radius: 16px;
        }
      }
    }
    .tip {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      text-shadow: 0 0 0 20px #000;
      // padding-top: 30px;
      color: #fff;
      font-size: 28px;
    }
  }
  .bar {
    position: relative;
    height: 226px;
    width: 100%;
    padding-top: 40px;
    background: #f7f7f7;
    border-radius: 40px 40px 0px 0px;
    .close {
      position: absolute;
      top: 12px;
      right: 16px;
      padding: 18px;
      font-size: 30px;
    }
    .list {
      display: flex;
      .item {
        width: 25%;
        img {
          width: 100px;
          height: 100px;
          margin: 0 auto;
        }
        .text {
          padding-top: 24px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
